var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"main-card pa-3"},[_c('CustomerListFilterBar'),_c('CustomerListTable'),_c('CustomerListPagination'),_c('CustomerDetailModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }